import { produce } from "immer";
import {
  FETCH_FAQS,
  FETCH_FAQS_SUCCESS,
  FETCH_FAQS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_FAQS,
  ADD_FAQS_SUCCESS,
  ADD_FAQS_FAILURE,
  //
  EDIT_FAQS,
  EDIT_FAQS_SUCCESS,
  EDIT_FAQS_FAILURE,
  //
  DELETE_FAQS,
  DELETE_FAQS_SUCCESS,
  DELETE_FAQS_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingFaqs: false,
  Faqs: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentFaqs: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
};

const FaqsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_FAQS:
        draft.isFetchingFaqs = true;
        draft.currentFaqs = {};
        break;
      case FETCH_FAQS_SUCCESS:
        draft.isFetchingFaqs = false;
        draft.Faqs = action.payload;
        break;
      case FETCH_FAQS_FAILURE:
        draft.isFetchingFaqs = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentFaqs = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentFaqs = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_FAQS:
        draft.isSubmitting = true;
        break;
      case ADD_FAQS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_FAQS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_FAQS:
        draft.isSubmitting = true;
        break;
      case EDIT_FAQS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_FAQS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_FAQS:
        draft.isDeleting = true;
        break;
      case DELETE_FAQS_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_FAQS_FAILURE:
        draft.isDeleting = false;
        break;
      default:
        return state;
    }
  });

export default FaqsReducer;
